import { render, staticRenderFns } from "./condicoesgerais.vue?vue&type=template&id=69d98026&"
import script from "./condicoesgerais.vue?vue&type=script&lang=js&"
export * from "./condicoesgerais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports